import React, { useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../config/constants';
import { auth } from '../login/FirebaseConfig';
import { useNavigate } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { es } from 'date-fns/locale';
import EventoPreview from './EventoPreview';

const CrearEventoForm = () => {
    const [eventName, setEventName] = useState('');
    const [descripcion, setDescripcion] = useState('');
    const [eventDate, setEventDate] = useState(null);
    const [errorMessage, setErrorMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [image, setImage] = useState(null);
    const [imagePreview, setImagePreview] = useState(null);

    const navigate = useNavigate();

    const COLLECTION_NAME = 'eventos'; /* Nombre de la coleccion de firebase */

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImage(file);
            setImagePreview(URL.createObjectURL(file));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (!eventDate) {
            setErrorMessage('Por favor, selecciona una fecha para el evento.');
            return;
        }

        try {
            const idToken = await auth.currentUser.getIdToken();

            const formData = new FormData();
            formData.append("file", image);
            const responseImage = await axios.post(`${API_BASE_URL}/subirImagen`, formData, {
                headers: {
                    Authorization: `Bearer ${idToken}`,
                },
            });
            const imagePublicId = responseImage.data.public_id;

            const response = await axios.post(
                `${API_BASE_URL}/crearEvento`,
                { collectionName: COLLECTION_NAME, eventName, descripcion, eventDate, imagePublicId },
                {
                    headers: {
                        Authorization: `Bearer ${idToken}`,
                    },
                }
            );

            navigate("/administradorEventos");
            window.location.reload();
        } catch (error) {
            setErrorMessage(error.response?.data?.error || 'Error al crear el evento');
        } finally {
            setIsLoading(false);
        }
    };

    const handleCancelar = async () => {
        navigate('/administradorEventos');
    };

    return (
        <div className="container mt-4">
            <h2 className="mb-4">Crear Evento</h2>
            <form onSubmit={handleSubmit}>
                <div className="mb-3">
                    <label htmlFor="eventName" className="form-label">
                        Nombre del Evento *
                    </label>
                    <input
                        type="text"
                        className="form-control"
                        id="eventName"
                        value={eventName}
                        onChange={(e) => setEventName(e.target.value)}
                        required
                    />
                </div>
                <div className="mb-3">
                    <label htmlFor="descripcion" className="form-label">
                        Descripción
                    </label>
                    <textarea
                        className="form-control"
                        id="descripcion"
                        value={descripcion}
                        onChange={(e) => setDescripcion(e.target.value)}
                    />
                </div>
                <div className="mb-3">
                    <label htmlFor="eventDate" className="form-label">
                        Fecha del Evento *
                    </label>
                    <br />
                    <DatePicker
                        selected={eventDate}
                        onChange={(date) => setEventDate(date)}
                        className="form-control"
                        dateFormat="dd/MM/yyyy h:mm aa"
                        timeFormat="HH:mm"
                        showTimeSelect
                        timeIntervals={1}
                        minDate={new Date()}
                        placeholderText="Selecciona una fecha"
                        locale={es}
                        required
                        popperPlacement="right-start"
                        timeCaption="Hora"
                    />
                </div>
                <div className="mb-3">
                    <label htmlFor="imageUpload" className="form-label">
                        Subir Imagen *
                    </label>
                    <input
                        type="file"
                        className="form-control"
                        id="imageUpload"
                        accept="image/*"
                        onChange={handleImageChange}
                    />
                </div>
                <p style={{ fontSize: "0.85em", color: "rgba(0, 0, 0, 0.6)", marginTop: "10px" }}>
                    Los campos marcados con <span>(*)</span> son obligatorios.
                </p>
                <button type="submit" className="btn btn-primary mb-2" disabled={isLoading}>
                    {isLoading ? (
                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    ) : (
                        'Crear Evento'
                    )}
                </button>
                <button type="button" className="btn btn-danger mb-2 mx-2" onClick={handleCancelar}>Cancelar</button>
            </form>
            {errorMessage && (
                <div className="alert alert-danger mt-3" role="alert">
                    {errorMessage}
                </div>
            )}
            <h2 style={{ textAlign: "center" }}>Vista Previa</h2>
            <EventoPreview
                theme="dtc"
                eventName={eventName}
                descripcion={descripcion}
                eventDate={eventDate}
                imagePreview={imagePreview}
            />
        </div>
    );
};

export default CrearEventoForm;
